/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  onGenerateTokenSubmit,
  onGenerateTokenSubmitReset,
} from "../../Store/Slices/generateTokenSlice";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import {
  validateLoginTokenUpdated,
} from "../../Store/Slices/validateLoginTokenSlice";
import {
  onGetMember,

  onPostMember,
} from "../../Store/Slices/getMemberSlice";
import {
  ApiConfigData,
  decodeBase64,
} from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { toast } from "react-toastify";
import { onLandingHome } from "../../Store/Slices/homePageLandingSlice";

const LoginPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const translation = getTranslation();
  const apiconfig = ApiConfigData();
  const partnerCode = apiconfig?.find(
    (data) => data?.paramsKey === "partnerCode"
  )?.paramsValue;
  const accessKey = apiconfig?.find(
    (data) => data?.paramsKey === "accessKey"
  )?.paramsValue;
  const secrateKey = apiconfig?.find(
    (data) => data?.paramsKey === "secrateKey"
  )?.paramsValue;
  const clientCode = apiconfig?.find(
    (data) => data?.paramsKey === "clientCode"
  )?.paramsValue;
  const integrationSecretKey = apiconfig?.find(
    (data) => data?.paramsKey === "integrationSecretKey"
  )?.paramsValue;
  const generateToken = useSelector((state) => state.generateTokenSliceReducer);
  const homePageSlice = useSelector((state) => state.homePageSliceReducer)

  const loginToken = useSelector(
    (state) => state.validateLoginTokenSliceReducer
  );
  const urlIndex = location.pathname.split("/");

  // Set session tokens on initial load
  useEffect(() => {

    sessionStorage.setItem("loginSessionToken", urlIndex[2]);
    sessionStorage.setItem("temporaryToken", urlIndex[3]);
    sessionStorage.setItem("login", true);
    sessionStorage.setItem("postLoginSuccesCount", 1);
    if (partnerCode) {
      if ((typeof homePageSlice?.homePageData === "object" && Object.keys(homePageSlice?.homePageData).length === 0)) {
        dispatch(onLandingHome())
      }

      dispatch(
        onGenerateTokenSubmit({
          partnerCode: partnerCode,
          clientCode: clientCode,
          accessKey: accessKey,
          secrateKey: secrateKey,
        })
      );

    }
  }, [partnerCode]);

  // Handle generate token response
  useEffect(() => {
    if (generateToken?.status_code === 200) {
      sessionStorage.removeItem("postLoginTriggered");

      setTimeout(() => {
        axiosIntegration.defaults.headers[
          "access-token"
        ] = `${generateToken?.data?.accessToken}`;
        
        dispatch(validateLoginTokenUpdated({
          loginSessionToken: sessionStorage.getItem("loginSessionToken"),
          integrationSecretKey: integrationSecretKey,
          temporaryToken: sessionStorage.getItem("temporaryToken"),
          urlReferrer: "",
          clientCode: clientCode,
          partnerCode: partnerCode,
        })).then((res) => {
          if (res?.payload?.data?.responseCode === "200") {
            dispatch(onGetMember(res?.payload?.data));
            dispatch(onGenerateTokenSubmitReset());
            const redirectPath = res?.payload?.data?.response?.redirectPath;
            if (redirectPath) {
              try {
                const decodedPath = decodeBase64(redirectPath);
                let finalPath = decodedPath.replace("claim-bonus", "welcome-bonus");
                sessionStorage.setItem("postLoginSuccesCount", 2);
                navigate(finalPath.startsWith("/") ? finalPath : `/${finalPath}`);
              } catch (error) {
                console.error("Invalid redirect path:", error);
                navigate("/");
              }
            } else {
              navigate("/");
            }
          }
        });
        sessionStorage.setItem("postLoginTriggered", true);
      }, 1000);

    }
  }, [generateToken]);
  // Handle login token validation response
  useEffect(() => {
    if (loginToken?.status_code === "400" || loginToken?.status_code === '401' || loginToken?.status_code === 401 || loginToken?.status_code === 400) {
      if (loginToken?.message) {
        toast.error(loginToken?.message);
      } else {
        toast.error(translation?.invalidLoginToken);
      }
      sessionStorage.clear();
      navigate("/");

    }
  }, [loginToken]);

  return (
    <div>
      {(generateToken?.isLoading) && <></>}
    </div>
  );
};

export default LoginPage;
